<div class="d-flex align-items-center">
    @if (tile.icon) {
        <wdx-icon class="mx-1 text-gray-500" [icon]="tile.icon"></wdx-icon>
    }
    <div class="sub-small mr-1">{{ tile.value }}</div>
</div>
<div class="overline gray-600 text-center mt-1">{{ tile.label }}</div>
